import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class InvalidOtherSellerNameError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.company.validation.other-seller.name');
    }
}
